import React from "react"

function TitleComponent() {
    return (
        <React.Fragment>
            <img src="https://img.icons8.com/external-icongeek26-linear-colour-icongeek26/64/external-broccoli-vegetables-icongeek26-linear-colour-icongeek26.png" alt="security icon" />
            <h4 className="mb-4">Vegan Marketplace</h4>
        </React.Fragment>
    )
}

export default TitleComponent